import { OverlayDesignTokens } from '../types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = WeaveTheme['tokens'];

export const getOverlayTokens = (tokens: WeaveTokens): OverlayDesignTokens => {
  const tooltip = tokens?.component?.tooltip;
  const popover = tokens?.component?.popover;
  const white = tokens?.generic?.color?.white;
  const charcoal = tokens?.generic?.color?.charcoal;
  const darkGray = tokens?.generic?.color?.['dark-gray'];

  const defaultStyle = {
    'background-color': tooltip?.['background-color'],
    'text-color': tooltip?.['text-color'],
    'border-color': tooltip?.['background-color'],
    'border-radius': tooltip?.['border-radius'],
  };

  const darkStyle = {
    'background-color': darkGray?.[100]?.[100],
    'text-color': charcoal?.[100]?.[100],
    'border-color': darkGray?.[100]?.[100],
    'border-radius': tooltip?.['border-radius'],
  };

  const mediumStyle = {
    'background-color': charcoal?.[100]?.[100],
    'text-color': charcoal?.[900]?.[100],
    'border-color': charcoal?.[100]?.[100],
    'border-radius': tooltip?.['border-radius'],
  };

  const lightStyle = {
    'background-color': white?.[100],
    'text-color': charcoal?.[900]?.[100],
    'border-color': white?.[100],
    'border-radius': tooltip?.['border-radius'],
    'box-shadow': `${popover?.['box-shadow-x']} ${popover?.['box-shadow-y']} ${popover?.['box-shadow-blur']} ${popover?.['box-shadow-color']}`,
  };

  return {
    light: lightStyle,
    medium: mediumStyle,
    dark: darkStyle,
    default: defaultStyle,
  };
};
